import {
    DEALERVIEWDSRLIST_FAILED,
    DEALERVIEWDSRLIST_SUCCESS,
    RESET_DEALERVIEWDSRLIST,
    LOADING_DEALERVIEWDSRLIST,
    NETWORK_ERROR_DEALERVIEWDSRLIST

} from '../types/index';
import { dealerServices } from "../../config/axios";

const resetDealerViewDsrList = () => {
    return { type: RESET_DEALERVIEWDSRLIST };
};

const dealerViewDsrList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERVIEWDSRLIST });
    await dealerServices
        .post("viewDsrList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerViewDsrListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerViewDsrListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERVIEWDSRLIST,
                payload: err
            });
        });
};

function dealerViewDsrListsuccess(data) {
    return {
        type: DEALERVIEWDSRLIST_SUCCESS,
        payload: data
    };
}
function dealerViewDsrListFailed(data) {
    return {
        type: DEALERVIEWDSRLIST_FAILED,
        payload: data
    };
}

export { resetDealerViewDsrList, dealerViewDsrList }